import React, { useState } from 'react';
import { Image, ImageProps } from 'react-bootstrap';
import './avatar.scss';

type AvatarProps = ImageProps & {
  src?: string;
  alt?: string;
  userName?: string;
  fallbackText?: string;
};

const Avatar: React.FC<AvatarProps> = ({
  src = '',
  alt = 'Avatar',
  userName,
  fallbackText,
  width = 100,
  height = 100,
  ...props
}) => {
  const [imageError, setImageError] = useState(false);

  // Generate initials from userName or fallbackText
  const getInitials = () => {
    if (fallbackText) return fallbackText;
    if (userName) {
      const names = userName.trim().split(' ');
      if (names.length >= 2) {
        return `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase();
      }
      return userName.substring(0, 2).toUpperCase();
    }
    return 'U';
  };

  const handleImageError = () => {
    setImageError(true);
  };

  if (imageError || !src) {
    return (
      <div
        className="avatar-placeholder"
        style={{
          width: typeof width === 'number' ? `${width}px` : width,
          height: typeof height === 'number' ? `${height}px` : height,
        }}
      >
        {getInitials()}
      </div>
    );
  }

  return (
    <Image
      src={src}
      alt={alt}
      width={width}
      height={height}
      roundedCircle
      onError={handleImageError}
      {...props}
    />
  );
};

export default Avatar;
